import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const insightsSectionDefinition: ComponentDefinition = {
  id: 'insightsSection',
  name: 'Insights Section',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/layout-grid.svg',
  children: true,
  variables: {
    sectionId: {
      type: 'Text',
      displayName: 'Section ID (anchor)',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    badge: {
      type: 'Text',
      displayName: 'Badge',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    title: {
      type: 'Text',
      displayName: 'Title',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    subHeading: {
      type: 'RichText',
      displayName: 'Sub Heading',
    },
    isBackgroundDark: {
      type: 'Boolean',
      displayName: 'Dark Background (text colour)',
      defaultValue: false,
      group: 'style',
    },
    layoutMode: {
      type: 'Text',
      displayName: 'Layout',
      defaultValue: 'carousel',
      group: 'style',
      validations: {
        in: [
          { value: 'carousel', displayName: 'Carousel' },
          { value: 'grid', displayName: 'Grid' },
        ],
      },
    },
    cardMode: {
      type: 'Text',
      displayName: 'Card Mode',
      defaultValue: 'manual',
      group: 'style',
      validations: {
        in: [
          { value: 'manual', displayName: 'Manual (children)' },
          { value: 'auto', displayName: 'Auto (fetch)' },
        ],
      },
    },
    showBlog: {
      type: 'Boolean',
      displayName: 'Blog',
      defaultValue: false,
      group: 'style',
    },
    showNews: {
      type: 'Boolean',
      displayName: 'News',
      defaultValue: false,
      group: 'style',
    },
    showCaseStudy: {
      type: 'Boolean',
      displayName: 'Case Study',
      defaultValue: false,
      group: 'style',
    },
    showMarketingInsights: {
      type: 'Boolean',
      displayName: 'Marketing Insights',
      defaultValue: false,
      group: 'style',
    },
    showEvent: {
      type: 'Boolean',
      displayName: 'Event',
      defaultValue: false,
      group: 'style',
    },
    showWebinar: {
      type: 'Boolean',
      displayName: 'Webinar',
      defaultValue: false,
      group: 'style',
    },
    enableAutoscroll: {
      type: 'Boolean',
      displayName: 'Enable Autoscroll',
      defaultValue: false,
      group: 'style',
    },
    autoscrollSpeed: {
      type: 'Number',
      displayName: 'Autoscroll Speed (ms)',
      defaultValue: 4000,
      group: 'style',
    },
  },
} as const;
